import React, { useState } from 'react';
import { Monitor, X } from 'lucide-react';

function ResponsiveWarningModal({ isOpen, onClose, t }) {
    const [dontShowAgain, setDontShowAgain] = useState(false);
    
    if (!isOpen) return null;
    
    const handleClose = () => {
        if (dontShowAgain) {
            // Store preference in localStorage
            localStorage.setItem('hideResponsiveWarning', 'true');
        }
        onClose();
    };
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] px-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative">
                {/* Close button */}
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <X size={20} />
                </button>
                
                {/* Icon */}
                <div className="flex justify-center mb-4">
                    <div className="bg-amber-100 p-4 rounded-full">
                        <Monitor className="w-12 h-12 text-amber-600" />
                    </div>
                </div>
                
                {/* Title */}
                <h2 className="text-xl font-bold text-center text-gray-800 mb-3">
                    {t('responsiveWarningTitle')}
                </h2>
                
                {/* Message */}
                <p className="text-gray-600 text-center mb-6">
                    {t('responsiveWarningMessage')}
                </p>
                
                {/* Don't show again checkbox */}
                <div className="flex items-center justify-center mb-4">
                    <label className="flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                            className="mr-2 h-4 w-4 text-sky-600 focus:ring-sky-500 border-gray-300 rounded"
                        />
                        <span className="text-sm text-gray-600">{t('dontShowResponsiveWarning')}</span>
                    </label>
                </div>
                
                {/* Action button */}
                <button
                    onClick={handleClose}
                    className="w-full bg-sky-600 text-white py-2.5 px-4 rounded-lg font-medium hover:bg-sky-700 transition-colors focus:outline-none focus:ring-2 focus:ring-sky-500"
                >
                    {t('understood')}
                </button>
            </div>
        </div>
    );
}

export default ResponsiveWarningModal;